import {useEffect, useReducer, useState} from 'react'
import {ERROR_STORE} from '../interface/_script'
import {
   useAccountAction,
   useAccountReducer,
   useAccountState,
} from '../reducer/reducer'
import {provinceData} from 'common/address'
import StringUtils from 'util/stringUtils'
import {sendRequestAuth} from '../../../api/api'
import config from '../../../config'
import ArrayUtils from '../../../Pages/orderSingle/utils/array'
import {useTranslation} from 'react-i18next'

export const useEditStore = (info, isUpdate) => {
   const {t} = useTranslation()
   const [state, dispatch] = useReducer(useAccountReducer, useAccountState)
   const [checkEmty, setCheckEmty] = useState(false)
   const [infoName, setInfoname] = useState(info?.shopname)
   const [errorName, setErrorName] = useState({valid: false, message: ''})
   const [infoPhone, setInfoPhone] = useState(info?.phone)
   const [errorPhone, setErrorPhone] = useState({valid: false, message: ''})
   const [infoEmail, setInfoEmail] = useState(info?.email)
   const [errorEmail, setErrorEmail] = useState({valid: false, message: ''})
   const checkDisable = [
      errorName?.valid,
      errorPhone?.valid,
      errorEmail?.valid,
   ].includes(true)
   const {customerInfo} = state.form

   const [checkAddress, setCheckAddress] = useState(false)
   const addressData = customerInfo.address

   useEffect(() => {
      if (addressData.province.value && addressData.ward.list.length === 0) {
         const wardList = provinceData
            .find(item => item.value === addressData.province.value)
            ?.list.map(ward => ({
               name: ward.name,
               value: ward.id,
            }))
         dispatch({
            type: useAccountAction.FORM_ADDRESS_WARD_KEYWORD_UPDATE,
            payload: {list: wardList, keyword: ''},
         })
      }
   }, [addressData.province.value])

   const handleAddressChange = val => {
      isUpdate(true)
      dispatch({
         type: useAccountAction.FORM_ADDRESS_UPDATE,
         payload: {value: val},
      })
   }
   useEffect(() => {
      if (info) {
         dispatch({
            type: useAccountAction.FORM_ADDRESS_UPDATE,
            payload: {value: info?.address},
         })

         const findProvince = provinceData.find(
            item => item.value === `${info?.city_id}`,
         )
         let wardList = []
         if (findProvince) {
            wardList = findProvince.list.map(ward => ({
               name: ward.name,
               value: ward.id,
            }))
            let findWard = wardList.find(item => item.value === `${info?.ward_id}`)

            if (info?.ward_id && info?.ward_name) {
               const apiWard = {
                  name: info.ward_name,
                  value: info.ward_id,
               }
               if (!findWard) {
                  findWard = apiWard
               }
               if (!wardList.some(item => item.value === apiWard.value)) {
                  wardList.unshift(apiWard)
               }
            }

            const dedupedWardList = wardList.filter(
               (item, idx, arr) =>
                  arr.findIndex(i => i.value === item.value) === idx,
            )
            dispatch({
               type: useAccountAction.FORM_ADDRESS_PROVINCE_UPDATE,
               payload: {
                  province: {value: findProvince},
                  ward: {
                     list: dedupedWardList,
                     value: findWard || null,
                  },
               },
            })
         }
      }
   }, [info])

   const handleProvinceChange = data => {
      isUpdate(true)

      const findProvince = provinceData.find(item => item.value === data.value)
      let wardList = []
      if (findProvince) {
         wardList = findProvince.list.map(ward => ({
            name: ward.name,
            value: ward.id,
         }))
      }
      dispatch({
         type: useAccountAction.FORM_ADDRESS_PROVINCE_UPDATE,
         payload: {
            province: {value: data},
            ward: {
               list: wardList,
            },
         },
      })
   }

   const handleWardChange = (data, opt) => {
      isUpdate(true)
      dispatch({
         type: useAccountAction.FORM_ADDRESS_WARD_UPDATE,
         payload: {ward: {value: data}},
      })
   }

   const handleWardKeywordChange = data => {
      const formatDataValue = data?.value
         ? StringUtils.removeAccents(data?.value?.toLowerCase())
         : ''
      const {province} = addressData
      let wardList = []
      if (province.value) {
         const findProvince = provinceData.find(
            item => item.value === province.value.value,
         )
         if (findProvince) {
            wardList = findProvince.list.map(ward => ({
               name: ward.name,
               value: ward.id,
            }))
         }
      }
      let listData = wardList.filter(item => {
         const formatNameItem = item?.name
            ? StringUtils.removeAccents(item.name.toLowerCase())
            : ''
         if (formatNameItem.includes(formatDataValue.trim())) return true
         return false
      })

      if (
         addressData.ward.value &&
         !listData.some(item => item.value === addressData.ward.value.value)
      ) {
         listData.push(addressData.ward.value)
      }
      dispatch({
         type: useAccountAction.FORM_ADDRESS_WARD_KEYWORD_UPDATE,
         payload: {list: listData, keyword: data?.value || ''},
      })
   }

   const handleProvinceKeywordChange = data => {
      const formatDataValue = data?.value
         ? StringUtils.removeAcent(data?.value?.toLowerCase())
         : ''
      const listData = provinceData.filter(item => {
         const formatNameItem = item?.name
            ? StringUtils.removeAcent(item.name.toLowerCase())
            : ''
         if (formatNameItem.includes(formatDataValue.trim())) return true
         return false
      })
      dispatch({
         type: useAccountAction.FORM_ADDRESS_PROVINCE_KEYWORD_UPDATE,
         payload: {list: listData, keyword: data?.value || ''},
      })
   }

   const onChangeNameStore = value => {
      isUpdate(true)
      setInfoname(value)
   }
   const onBlurNameStore = value => {
      if (value == '')
         setErrorName({valid: true, message: t(ERROR_STORE.NAME.EMPTY_NAME)})
      else if (value.length > 100)
         setErrorName({valid: true, message: t(ERROR_STORE.NAME.MAX_NAME)})
      else {
         setErrorName({valid: false, message: ''})
      }
   }
   const onChangePhoneStore = value => {
      isUpdate(true)
      setErrorPhone({valid: false, message: ''})
      const re = /^[0-9\b]+$/
      if (value == '' || re.test(value)) {
         setInfoPhone(value)
      }
   }
   const onBlurPhoneStore = value => {
      if (value == '')
         setErrorPhone({valid: true, message: t(ERROR_STORE.PHONE.EMPTY_PHONE)})
      else if (value.length < 10)
         setErrorPhone({valid: true, message: t(ERROR_STORE.PHONE.MAX_PHONE)})
      else if (value.length > 11)
         setErrorPhone({valid: true, message: t(ERROR_STORE.PHONE.MAX_PHONE)})
      else {
         setErrorPhone({valid: false, message: ''})
      }
   }
   const onChangeEmailStore = value => {
      isUpdate(true)
      setInfoEmail(value)
   }
   const onBlurEmailStore = value => {
      let regex =
         /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (value === '') setErrorEmail({valid: false, message: ''})
      else if (!regex.test(value))
         setErrorEmail({valid: true, message: t(ERROR_STORE.EMAIL.REGEX_EMAIL)})
      else if (value.length > 255)
         setErrorEmail({valid: true, message: t(ERROR_STORE.EMAIL.MAX_EMAIL)})
      else {
         setErrorEmail({valid: false, message: ''})
      }
   }

   return {
      checkEmty,
      checkDisable,
      check_name: {
         onChangeNameStore,
         onBlurNameStore,
         errorName,
         infoName,
      },
      check_phone: {
         onChangePhoneStore,
         onBlurPhoneStore,
         errorPhone,
         infoPhone,
      },
      check_email: {
         onChangeEmailStore,
         onBlurEmailStore,
         infoEmail,
         errorEmail,
      },
      data: customerInfo,
      methods: {
         onAddressChange: handleAddressChange,
         onProvinceChange: handleProvinceChange,
         onProvinceKeywordChange: handleProvinceKeywordChange,
         onWardChange: handleWardChange,
         onWardKeywordChange: handleWardKeywordChange,
      },
      list_id: {
         address: state.form.customerInfo?.address.value,
         id_city: state.form.customerInfo?.address.province.value,
         id_ward: state.form.customerInfo?.address.ward.value,
      },
      checkAddress,
   }
}
